@if (buttonOptions().length > 0) {
  <div class="flex-vertical gap-16 cat-container with-border-bottom">
    <div class="flex-horizontal flex-center gap-8 cat-info">
      <oui-icon class="cat-icon">{{ line().getIcon() }}</oui-icon>
      <div class="subtitle-1">{{ title }}</div>
    </div>
    <div class="flex-horizontal flex-center gap-16 filtre-container">
      @for (butt of buttonOptions(); track butt.value) {
        <oui-button
          (click)="toggleButtonStatut(butt)"
          [type]="butt.isSelected ? 'contained' : 'outlined'">
          {{ butt.label }}
        </oui-button>
      }
    </div>
  </div>
}
